import React from 'react';
import { useParams } from 'react-router-dom';
import UserService from '../services/UserService';
import SEO from './SEO';
import DealListPage from './DealListPage';

function Category() {
  let { category } = useParams();
  const title = category.toLowerCase() === 'freebies' ? 'Freebies' : `${category} Deals`;

  return (
    <>
      <SEO title={title} description={`The best ${category} deals, hand-picked daily by DinoDealz.`} />
      <DealListPage
        title={title}
        crumb={category}
        loadDeals={() => UserService.getcategoryDeals(category)}
        reloadKey={category}
        activeCategory={category}
        emptyText={`No ${category} deals right now. Check back soon!`}
      />
    </>
  );
}

export default Category;
